import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Form } from 'ui/components';

const initialState = {
  items: [
    {
      id: null,
      plan_item: null,
      item_id: null,
      quantity_planned: null,
      quantity: null,
    },
  ],
};

export const FormItems = ({ data, plan, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ items }, setState] = React.useState(initialState);

  const $handleOnCheck = async(i) => {
    let newItems = [...items];

    newItems[i]['quantity'] = newItems[i].quantity_planned;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  }

  const $handleItemsChange = async (i, e) => {
    let newItems = [...items];

    newItems[i]['quantity'] = e.target.valueNumber;

    setState((prevState) => ({
      ...prevState,
      items: newItems,
    }));
  };

  React.useEffect(() => {
    const input = {
      items,
    };

    onInputChange(input);
  }, [items]);

  React.useEffect(() => {
    if (!data) return;

    let b = [];
    if (data) {
      data?.items?.forEach((i) => {
        i.plan_item.quantity_planned_fracted = i?.quantity_planned_fracted
        b.push({
          id: i?.id,
          plan_item: i?.plan_item,
          item_id: i?.plan_item?.id,
          quantity_planned: i?.quantity_planned,
          quantity: i?.quantity_fulfilled,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [data]);

  React.useEffect(() => {
    if (!plan) return;

    let b = [];
    if (plan) {
      plan?.items?.forEach((i) => {
        b.push({
          plan_item: i,
          item_id: i?.id,
          quantity_planned: i?.quantity_planned,
          quantity: null,
        });
      });
    }
    setState((prevState) => ({ ...prevState, items: b }));
  }, [plan]);

  return (
    <div className='bg-white py-md-3 px-3 border-top border-bottom'>
      <div className="row">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Delivery Plan Item
          </div>
          <div className="table-responsive bg-white">
            <table
              width="100%"
              className="table table-hover table-vcenter card-table datatable border"
            >
              <thead className="bg-light">
                <tr className="th">
                  <td style={{width: '5%'}}>No</td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '40%',
                    }}
                  >
                    Item
                  </td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '10%',
                      textAlign: 'center',
                    }}
                  >
                    Quantity Planned
                  </td>
                  <td
                    style={{
                      whiteSpace: 'nowrap',
                      width: '15%',
                      textAlign: 'center',
                    }}
                  >
                    Quantity
                  </td>
                  <td></td>
                  <td style={{width: '8%'}}></td>
                </tr>
              </thead>
              <tbody>
                {items?.map((d, i) => (
                  <tr
                    key={i}
                    className={cn(
                      StateForm?.errors[`items.${i}.item_id`]
                        ? 'text-dangers border-danger'
                        : null
                    )}
                  >
                    <td>{i + 1}</td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <div className="table-col text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {d?.plan_item?.item?.alias_name}
                        </div>
                        <small className="info text-ellipsis">{d?.plan_item?.item?.code}</small>
                      </div>
                      {StateForm?.errors[`items.${i}.item_id`] ? (
                        <div className="invalid-feedback d-block ">
                          {StateForm?.errors[`items.${i}.item_id`]}
                        </div>
                      ) : null}
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <div className="table-col text-center text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {d?.quantity_planned} {d?.plan_item?.item?.default_fraction}
                        </div>
                        <small className="info text-ellipsis">{d?.plan_item?.quantity_planned_fracted}</small>
                      </div>
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '40%' }}>
                      <Form.Input
                        autoComplete="off"
                        name="quantity"
                        type="number"
                        value={d?.quantity}
                        onChange={(e) => $handleItemsChange(i, e)}
                        error={
                          StateForm?.errors[`items.${i}.quantity`]
                        }
                        mb0
                        withFraction={d?.plan_item?.item?.default_fraction}
                      />
                    </td>
                    <td style={{ whiteSpace: 'nowrap'}}>
                      {d?.plan_item?.item?.default_fraction}
                    </td>
                    <td className="text-end">
                      <div
                        className="btn-toolbar justify-content-end"
                        role="toolbar"
                      >
                        <div className="input-group" role="group">
                          <input className="form-check-input mt-0" type="checkbox" onClick={() => $handleOnCheck(i)}/>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
